import { Theme, createStyles } from "@material-ui/core";

export const styles = (theme: Theme) =>
  createStyles({
    root: {
      marginTop: 40,
      backgroundColor: "#FAFAFA",
      borderRadius: "30px 0px 0px 30px",
      padding: "32px 30px",
      [theme.breakpoints.down("xs")]: {
        padding: "15px 10px",
      },
    },
    modal: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    modalContent: {
      margin: "auto",
      position: "relative",
      width: "40%",
      height: "auto",
      minHeight: "35%",
      backgroundColor: "#fafafa",
      justifyContent: "flex-start",
      display: "flex",
      alignItems: "flex-start",
      flexFlow: "column",
      borderRadius: "30px 30px 30px 30px",
      textAlign: "center",
      padding: "22px",
      [theme.breakpoints.down("sm")]: {
        width: "95%",
        padding: "25px 10px 5px",
      },
    },
    modalWarningContent: {
      margin: "auto",
      position: "relative",
      width: "45%",
      height: "auto",
      minHeight: "35%",
      backgroundColor: "#fafafa",
      justifyContent: "center",
      display: "flex",
      alignItems: "center",
      flexFlow: "column",
      borderRadius: "30px 30px 30px 30px",
      textAlign: "center",
      padding: "40px 20px 0px",
      [theme.breakpoints.down("sm")]: {
        width: "95%",
        padding: "25px 10px 5px",
      },
    },
    modalRow: {
      display: "flex",
      justifyContent: "center",
      alignItems: "baseline",
      width: "100%",
      "& div": {
        flex: 1,
      },
      "& button": {
        color: "#1779C0",
      },
    },
    modalIcon: {
      width: 84,
      height: 84,
      marginBottom: 35,
    },
    modalTitle: {
      fontWeight: 500,
      fontSize: 24,
      lineHeight: "28.13px",
      letterSpacing: "0%",
      textAlign: "center",
      color: "#3B465C",
      marginBottom: 15,
    },
    modalDescription: {
      fontWeight: 400,
      fontSize: 16,
      lineHeight: "18.75px",
      letterSpacing: "0%",
      textAlign: "center",
      color: "#3B465C99",
      marginBottom: 8,
    },
    modalButtons: {
      display: "flex",
      gap: "15px",
      height: 100,
      alignItems: "center",
    },
    modalCancel: {
      width: 160,
      height: 50,
      border: "1px solid #119BD0",
      color: "#119BD0",
      borderRadius: 15,
      boxShadow: "0px 3px 6px 0px #00000029",
    },
    modalAccept: {
      width: 160,
      height: 50,
      border: "1px solid #E34850",
      backgroundColor: "#E34850",
      color: "#fff",
      borderRadius: 15,
      boxShadow: "0px 3px 6px 0px #00000029",
    },
    warningBox: {
      backgroundColor: "#F29423",
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      gap: "15px",
      justifyContent: "space-between",
      padding: "15px",
      color: "white",
    },
    warningDescription: {
      fontWeight: 600,
      fontSize: 16,
      verticalAlign: "middle",
      color: "white",
      textAlign: "left",
    },
    titleMobile: {
      fontSize: 24,
      color: "#1779C0",
      fontWeight: 400,
      marginBottom: 10,
      textAlign: "center",
    },
    inputsGroup: {
      display: "flex",
      justifyContent: "flex-start",
      gap: "20px",
      width: "100%",
      flexWrap: "wrap",
      marginBottom: 15,
      [theme.breakpoints.down("xs")]: {
        flexDirection: "column",
      },
    },
    textField: {
      marginRight: 15,
      marginBottom: 15,
      "& .MuiOutlinedInput-root": {
        borderRadius: 8,
      },
    },
    formGroup: {
      backgroundColor: "#fff",
      borderRadius: 15,
      padding: "20px 30px",
      boxShadow: "0px 1px 3px 0px #0000001A",
      marginBottom: 15,
      "& h2": {
        fontSize: 24,
        color: "#6AC4E7",
        fontWeight: 400,
        marginBottom: 10,
        [theme.breakpoints.down("xs")]: {
          margin: 0,
          marginBottom: 10,
        },
      },
      [theme.breakpoints.down("xs")]: {
        padding: "15px",
      },
    },
    switch: {
      fontSize: 16,
      color: "#000",
      fontWeight: 400,
      marginRight: 15,
      [theme.breakpoints.down("xs")]: {
        marginBottom: 15,
      },
    },
    containerButtons: {
      display: "flex",
      justifyContent: "flex-end",
      gap: "15px",
      marginTop: 35,
    },
    buttonCancel: {
      width: 160,
      height: 50,
      border: "1px solid #119BD0",
      color: "#119BD0",
      borderRadius: 15,
      boxShadow: "0px 3px 6px 0px #00000029",
    },
    buttonConfirm: {
      width: 160,
      height: 50,
      border: "1px solid #004B81",
      background: "#004B81",
      color: "#fff",
      borderRadius: 15,
      boxShadow: "0px 3px 6px 0px #00000029",
    },
    buttonTokensContainer: {
      flex: 1,
      minWidth: 225,
      display: "flex",
      flexDirection: "row",
      alignItems: "flex-end",
      justifyContent: "flex-end",
      [theme.breakpoints.down("xs")]: {
        alignItems: "center",
        justifyContent: "center",
      },
    },
    buttonTokens: {
      height: 50,
      border: "1px solid #119BD0",
      color: "#119BD0",
      borderRadius: 15,
      boxShadow: "0px 3px 6px 0px #00000029",
      padding: "0px 15px",
      "& svg": {
        marginRight: "8px",
      },
    },
    contactGroup: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      gap: "20px",
      width: "100%",
      flexWrap: "wrap",
      marginBottom: 15,
      [theme.breakpoints.down("xs")]: {
        flexDirection: "column",
        padding: "15px",
      },
    },
    inputWithDelete: {
      position: "relative",
      paddingRight: "16px",
    },
    deleteButton: {
      position: "absolute",
      right: "2px",
      padding: "0",
      margin: "0",
      minWidth: "20px",
      top: "15px",
    },
  });
